// extracted by mini-css-extract-plugin
module.exports = {"icon-circle-wrapper":"IconNotificationCount_icon-circle-wrapper__343IM","icon-circle":"IconNotificationCount_icon-circle__2I6vZ"};